import { ChapterModel } from '../story/models/chapter.model';
import { uuid } from './uuid';

export namespace ChapterUtils {
  export function makeChapterIdMap(
    chapters: ChapterModel[],
    genNewIds: boolean
  ): Record<string, string> {
    return chapters.reduce((acc, chapter) => {
      acc[chapter.id] =
        genNewIds === true ? uuid.idWithPrefix('chapter') : chapter.id;
      return acc;
    }, {});
  }
}
